import { ReactElement } from 'react';
import { Text, TextProps } from '@chakra-ui/react';

import { PropsWithChildren } from 'lib/@types';

const CardSubTitle = ({
  children,
  ...props
}: PropsWithChildren<TextProps>): ReactElement => (
  <Text
    fontSize={['12px', '14px']}
    fontWeight='600'
    textAlign='left'
    {...props}
  >
    {children}
  </Text>
);

export default CardSubTitle;
